import React from "react"
import Nin9rsTeamLine from "@/components/Nin9rs/Nin9rsTeamLine"

const colorMapping = {
    ["blue"]: "#0000b3",
    ["red"]: "#ff3131",
    ["yellow"]: "#ffde59",
    ["green"]: "#007a3f",
    ["black"]: "#000",
    ["orange"]: "#ff751f",
    ["pink"]: "#f9a",
    ["purple"]: "#b300b2",
    ["fuchsia"]: "#fa009a",
    ["cyan"]: "#5ce1e6",
}

const RyderLivescoringTournamentHeaderNin9rsView = ({
    competition,
    teams,
    teamIds,
    isGroupingView
}) => {
    return (
        <div className="mb-2 h-full px-4 py-2 w-full max-w-7xl mx-auto shadow-xl space-y-6 container-marker-header">
            <div className={`flex flex-col-reverse w-full max-w-7xl mx-auto mb-1 sm:mb-4 sm:flex-row items-center justify-between min-w-0 lg:flex-col-reverse lg:items-center xl:items-center 2xl:items-center lg:mb-10`}>
                <div className="flex flex-col-reverse">
                    <h2 className="text-sm text-slate-500 text-center sm:text-left lg:text-center sm:text-base lg:text-sm xl:text-base 2xl:text-lg font-semibold uppercase tracking-wide m-1 sm:m-0 sm:mb-2">
                        Nin9rs
                    </h2>

                    <h1 className="text-2xl text-slate-600 text-center sm:text-left lg:text-center sm:text-2xl lg:text-lg xl:text-2xl 2xl:text-3xl font-bold uppercase tracking-wide m-1 sm:m-0 lg:mt-6 pb-2">
                        {competition.name}
                    </h1>
                </div>
                {
                    !isGroupingView &&
                    <img
                        className="h-6 sm:h-6 m-2 lg:mt-3 lg:block lg:mx-auto lg:h-7 xl:h-9 2xl:h-9 opacity-30"
                        src="https://assets.codepen.io/261257/LOGO_SIMPLE_2023_72_LS.svg"
                        alt="Logo nxt"
                    />
                }
            </div>

            <div className="w-full max-w-7xl mx-auto overflow-hidden rounded-lg sm:mb-0">
                <div className={`flex flex-col gap-4 sm:gap-8 sm:flex-row lg:gap-6 lg:flex-col`}>
                    {teamIds.map((teamId, idx) => {
                        return <Nin9rsTeamLine
                            key={teamId}
                            teamImageUrl={teams[teamId].imageUrl}
                            teamName={teams[teamId].name}
                            teamScore={teams[teamId].score.general}
                            teamColor={colorMapping[teams[teamId].color]}
                        />
                    })}
                </div>
            </div>
        </div>
    )
}

export default RyderLivescoringTournamentHeaderNin9rsView
